import React from "react";
import {css, Theme} from "@emotion/react";

import {m, mb, p, pl, pr} from "@pg-design/helpers-css";
import {Image} from "@pg-design/image-module";
import {Text} from "@pg-design/text-module";
import {numberFormat} from "@pg-mono/string-utils";

import {IVariablesStore} from "../../../variables/reducers/variables_reducer";

const logoPzdf = require("./../../img/logo_pzfd.svg");
const logoGpw = require("./../../img/logo_gpw.png");

interface IProps {
    vendor: {
        recommendation: {
            pzfd_member: number | null;
            stats: {
                label: number;
                value: number;
            }[];
        } | null;
    };
    variables: IVariablesStore;
}

export const getRecommendationStat = (vendor: IProps["vendor"], variables: IVariablesStore, stat_label_key: number) => {
    if (!variables.data || !vendor.recommendation) {
        return null;
    }

    const labelObj = variables.data.recommendation_stat_label.find((statLabel) => statLabel.value === stat_label_key);
    const statistics = vendor.recommendation.stats.find((stat) => stat.label === stat_label_key);

    if (!statistics || !labelObj) {
        return null;
    }

    return {
        label: labelObj.label,
        value: statistics.value
    };
};

export const VendorDetailRecommendation: React.FC<IProps> = ({vendor, variables}) => {
    const stats = vendor.recommendation?.stats
        ? vendor.recommendation.stats
              .map((stat) => getRecommendationStat(vendor, variables, stat.label))
              .filter(Boolean)
              .filter((stat) => stat && stat.label !== "Lat obecności na GPW")
        : [];

    const isPzfdMember = vendor.recommendation?.pzfd_member;
    const isListedOnGpw = vendor.recommendation?.stats?.some(({value, label}) => label === 6 && Number.isFinite(value));

    return (
        <div>
            <ul css={vendorRecommendationList}>
                {stats.map(
                    (stat) =>
                        stat && (
                            <li key={stat.label} css={vendorRecommendationListElement}>
                                <Text as="div" variant="headline_3" css={[mb(3)]}>
                                    {numberFormat(stat.value)}
                                </Text>

                                <Text as="div" variant="info_txt_1" css={vendorRecommendationLabel}>
                                    {stat.label}
                                </Text>
                            </li>
                        )
                )}

                {isPzfdMember && (
                    <li key="pzfd" css={vendorRecommendationListElement}>
                        <Image src={logoPzdf} alt="logo pzdf" width="85px" height="26px" css={[mb(3)]} />

                        <Text as="div" variant="info_txt_1" css={vendorRecommendationLabel}>
                            Członek PZFD
                        </Text>
                    </li>
                )}

                {isListedOnGpw && (
                    <li key="gpw" css={vendorRecommendationListElement}>
                        <Image src={logoGpw} alt="logo gpw" width="98px" height="29px" css={[mb(3)]} />

                        <Text as="div" variant="info_txt_1" css={vendorRecommendationLabel}>
                            Spółka notowana na GPW
                        </Text>
                    </li>
                )}
            </ul>
        </div>
    );
};

const vendorRecommendationList = (theme: Theme) => css`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    list-style: none;
    justify-content: flex-start;
    width: 100%;
    ${m(0)};
    ${p(0)};

    @media (min-width: ${theme.breakpoints.md}) {
        flex-wrap: nowrap;
    }
`;

const showVendorVerticalSeparator = (theme: Theme) => css`
    border-right: 1px solid ${theme.colors.gray["400"]};
`;

const hideVendorVerticalSeparator = css`
    border-right: none;
`;

const vendorRecommendationListElement = (theme: Theme) => css`
    display: flex;
    flex-direction: column;
    align-items: center;
    flex: 0 1 50%;
    width: 50%;
    ${p(1)};
    ${mb(3)};
    ${showVendorVerticalSeparator(theme)};

    &:first-child {
        ${pl(0)};
    }

    &:last-child {
        ${hideVendorVerticalSeparator};
        ${pr(0)};
    }

    &:nth-child(2n) {
        ${hideVendorVerticalSeparator};
    }

    @media (min-width: ${theme.breakpoints.md}) {
        flex: 1 1 auto;
        ${p(2, 2, 1)};

        &:nth-child(2n) {
            ${showVendorVerticalSeparator(theme)};
        }

        &:first-child {
            ${pl(0)};
        }

        &:last-child {
            ${pr(0)};
        }
    }
`;

const vendorRecommendationLabel = (theme: Theme) => css`
    text-align: center;
    color: ${theme.colors.gray["600"]};
`;
import React from "react";
import {css, Theme} from "@emotion/react";

import {m, mb, p, pl, pr} from "@pg-design/helpers-css";
import {Image} from "@pg-design/image-module";
import {Text} from "@pg-design/text-module";
import {numberFormat} from "@pg-mono/string-utils";

import {IVariablesStore} from "../../../variables/reducers/variables_reducer";

const logoPzdf = require("./../../img/logo_pzfd.svg");
const logoGpw = require("./../../img/logo_gpw.png");

interface IProps {
    vendor: {
        recommendation: {
            pzfd_member: number | null;
            stats: {
                label: number;
                value: number;
            }[];
        } | null;
    };
    variables: IVariablesStore;
}

export const getRecommendationStat = (vendor: IProps["vendor"], variables: IVariablesStore, stat_label_key: number) => {
    if (!variables.data || !vendor.recommendation) {
        return null;
    }

    const labelObj = variables.data.recommendation_stat_label.find((statLabel) => statLabel.value === stat_label_key);
    const statistics = vendor.recommendation.stats.find((stat) => stat.label === stat_label_key);

    if (!statistics || !labelObj) {
        return null;
    }

    return {
        label: labelObj.label,
        value: statistics.value
    };
};

export const VendorDetailRecommendation: React.FC<IProps> = ({vendor, variables}) => {
    const stats = vendor.recommendation?.stats
        ? vendor.recommendation.stats
              .map((stat) => getRecommendationStat(vendor, variables, stat.label))
              .filter(Boolean)
              .filter((stat) => stat && stat.label !== "Lat obecności na GPW")
        : [];

    const isPzfdMember = vendor.recommendation?.pzfd_member;
    const isListedOnGpw = vendor.recommendation?.stats?.some(({value, label}) => label === 6 && Number.isFinite(value));

    return (
        <div>
            <ul css={vendorRecommendationList}>
                {stats.map(
                    (stat) =>
                        stat && (
                            <li key={stat.label} css={vendorRecommendationListElement}>
                                <Text as="div" variant="headline_3" css={[mb(3)]}>
                                    {numberFormat(stat.value)}
                                </Text>

                                <Text as="div" variant="info_txt_1" css={vendorRecommendationLabel}>
                                    {stat.label}
                                </Text>
                            </li>
                        )
                )}

                {isPzfdMember && (
                    <li key="pzfd" css={vendorRecommendationListElement}>
                        <Image src={logoPzdf} alt="logo pzdf" width="85px" height="26px" css={[mb(3)]} />

                        <Text as="div" variant="info_txt_1" css={vendorRecommendationLabel}>
                            Członek PZFD
                        </Text>
                    </li>
                )}

                {isListedOnGpw && (
                    <li key="gpw" css={vendorRecommendationListElement}>
                        <Image src={logoGpw} alt="logo gpw" width="98px" height="29px" css={[mb(3)]} />

                        <Text as="div" variant="info_txt_1" css={vendorRecommendationLabel}>
                            Spółka notowana na GPW
                        </Text>
                    </li>
                )}
            </ul>
        </div>
    );
};

const vendorRecommendationList = (theme: Theme) => css`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    list-style: none;
    justify-content: flex-start;
    width: 100%;
    ${m(0)};
    ${p(0)};

    @media (min-width: ${theme.breakpoints.md}) {
        flex-wrap: nowrap;
    }
`;

const showVendorVerticalSeparator = (theme: Theme) => css`
    border-right: 1px solid ${theme.colors.gray["400"]};
`;

const hideVendorVerticalSeparator = css`
    border-right: none;
`;

const vendorRecommendationListElement = (theme: Theme) => css`
    display: flex;
    flex-direction: column;
    align-items: center;
    flex: 0 1 50%;
    width: 50%;
    ${p(1)};
    ${mb(3)};
    ${showVendorVerticalSeparator(theme)};

    &:first-child {
        ${pl(0)};
    }

    &:last-child {
        ${hideVendorVerticalSeparator};
        ${pr(0)};
    }

    &:nth-child(2n) {
        ${hideVendorVerticalSeparator};
    }

    @media (min-width: ${theme.breakpoints.md}) {
        flex: 1 1 auto;
        ${p(2, 2, 1)};

        &:nth-child(2n) {
            ${showVendorVerticalSeparator(theme)};
        }

        &:first-child {
            ${pl(0)};
        }

        &:last-child {
            ${pr(0)};
        }
    }
`;

const vendorRecommendationLabel = (theme: Theme) => css`
    text-align: center;
    color: ${theme.colors.gray["600"]};
`;
